import {
  Fish,
  Snowflake,
  Trophy,
  ShoppingBag,
  type LucideIcon,
} from 'lucide-react'

export interface Subcategory {
  name: string
  slug: string
  children?: Subcategory[]
}

export interface Category {
  name: string
  slug: string
  image?: string
  iconOnly?: boolean
  icon?: LucideIcon
  shortLabel?: string
  subcategories: Subcategory[]
}

export const categories: Category[] = [
  {
    name: 'Baseball',
    slug: 'baseball',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/2701544781354842.png',
    shortLabel: 'Jerseys, Pants & Cage Jackets',
    subcategories: [
      {
        name: 'Pants',
        slug: 'pants',
        children: [
          { name: 'Knickers', slug: 'knickers' },
          { name: 'Open Bottom', slug: 'open-bottom' },
        ],
      },
      {
        name: 'Jerseys',
        slug: 'jerseys',
        children: [
          { name: 'Full Button', slug: 'full-button' },
          { name: 'Two-Button', slug: 'two-button' },
          { name: 'No Button', slug: 'no-button' },
        ],
      },
      { name: 'Cage Jackets', slug: 'cage-jackets' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Football',
    slug: 'football',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/93693967735835.png',
    shortLabel: 'Jerseys, Pants & Tackle',
    subcategories: [
      { name: 'Football Pants', slug: 'football-pants' },
      {
        name: 'Jerseys',
        slug: 'jerseys',
        children: [
          {
            name: 'Tackle',
            slug: 'tackle',
            children: [
              { name: 'Form Fit Jerseys', slug: 'form-fit-jerseys' },
              { name: 'Tapered Jersey', slug: 'tapered-jersey' },
            ],
          },
          { name: 'Flag and Fan', slug: 'flag-and-fan' },
        ],
      },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Product Samples', slug: 'product-samples' },
          { name: 'Size Samples', slug: 'size-samples' },
        ],
      },
    ],
  },
  {
    name: 'Basketball',
    slug: 'basketball',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/7363850798889302.png',
    shortLabel: 'Jerseys, Shorts & Shooters',
    subcategories: [
      { name: 'Shooter Shirt', slug: 'shooter-shirt' },
      { name: 'Jersey', slug: 'jersey' },
      { name: 'Shorts', slug: 'shorts' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Softball',
    slug: 'softball',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/4223647075875688.png',
    shortLabel: 'Jerseys, Knickers & Cage Jackets',
    subcategories: [
      {
        name: 'Jerseys',
        slug: 'jerseys',
        children: [
          { name: 'Full Button', slug: 'full-button' },
          { name: 'Two-Button', slug: 'two-button' },
          { name: 'No Button', slug: 'no-button' },
        ],
      },
      { name: 'Knickers', slug: 'knickers' },
      { name: 'Cage Jackets', slug: 'cage-jackets' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Track and Field',
    slug: 'track-and-field',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/8455360050728445.png',
    shortLabel: 'Tops, Bottoms & Compression',
    subcategories: [
      {
        name: 'Tops',
        slug: 'tops',
        children: [
          { name: 'Standard', slug: 'standard' },
          { name: 'Compression', slug: 'compression' },
        ],
      },
      {
        name: 'Bottoms',
        slug: 'bottoms',
        children: [
          { name: 'Compression', slug: 'compression' },
          { name: 'Standard', slug: 'standard' },
        ],
      },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Wrestling',
    slug: 'wrestling',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/4209524088187243.png',
    shortLabel: 'Singlets, Shorts & Tops',
    subcategories: [
      { name: 'Singlet', slug: 'singlet' },
      { name: 'Shorts', slug: 'shorts' },
      { name: 'Top', slug: 'top' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Lacrosse',
    slug: 'lacrosse',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/4101599852116239.png',
    shortLabel: 'Jerseys, Shooters & Bottoms',
    subcategories: [
      { name: 'Jerseys', slug: 'jerseys' },
      { name: 'Shooter Shirt', slug: 'shooter-shirt' },
      { name: 'Bottoms', slug: 'bottoms' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Fishing',
    slug: 'fishing',
    iconOnly: true,
    icon: Fish,
    shortLabel: 'Performance Fishing Apparel',
    subcategories: [
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Hockey',
    slug: 'hockey',
    iconOnly: true,
    icon: Snowflake,
    shortLabel: 'Custom Hockey Apparel',
    subcategories: [
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Soccer',
    slug: 'soccer',
    iconOnly: true,
    icon: Trophy,
    shortLabel: 'Jerseys & Shorts',
    subcategories: [
      { name: 'Jerseys', slug: 'jerseys' },
      { name: 'Shorts', slug: 'shorts' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Volleyball',
    slug: 'volleyball',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/6782055902857249.png',
    shortLabel: 'Jerseys & Shorts',
    subcategories: [
      { name: 'Jersey', slug: 'jersey' },
      { name: 'Shorts', slug: 'shorts' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Cheer',
    slug: 'cheer',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/6387591952203024.png',
    shortLabel: 'Cheer Tops & Bottoms',
    subcategories: [
      { name: 'Cheer Bottoms', slug: 'cheer-bottoms' },
      { name: 'Cheer Tops', slug: 'cheer-tops' },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Groupwear',
    slug: 'groupwear',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/site12118-1.websiteforge.com/preview/uploaded/images/Kit%20Categories/1568287253023830.png',
    shortLabel: 'Hoodies & Varsity Jackets',
    subcategories: [
      {
        name: 'Hoodies',
        slug: 'hoodies',
        children: [
          {
            name: 'Cotton',
            slug: 'cotton',
            children: [{ name: 'Dyed', slug: 'dyed' }],
          },
          {
            name: 'Performance',
            slug: 'performance',
            children: [{ name: 'Dyed', slug: 'dyed' }],
          },
        ],
      },
      {
        name: 'Varsity / Letterman Jackets',
        slug: 'varsity-letterman-jackets',
      },
      {
        name: 'Samples',
        slug: 'samples',
        children: [
          { name: 'Size Samples', slug: 'size-samples' },
          { name: 'Product Samples', slug: 'product-samples' },
        ],
      },
    ],
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    iconOnly: true,
    icon: ShoppingBag,
    shortLabel: 'Bags & Team Accessories',
    subcategories: [
      { name: 'Home and Life', slug: 'home-and-life' },
      { name: 'Bags', slug: 'bags' },
    ],
  },
]
